module.exports = __webpack_public_path__ + "app/components/Imgs/KamereoLogo.svg";